import { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

const ShapeToCssValue = {
  circle: '50%',
  round: '4px',
  square: '0px',
};

const Sizes = {
  base: '40px',
  md: '56px',
  sm: '32px',
};

const AvatarWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ size }) => Sizes[size]};
  height: ${({ size }) => Sizes[size]};
  border: 1px solid ${theme.colors.gray400};
  text-align: center;
  border-radius: ${({ shape }) => ShapeToCssValue[shape]};
  background-color: ${({ color }) => color};
  overflow: hidden;
  > img {
    filter: invert(100%);
    width: 110%;
    transition: opacity 0.2s ease-out;
  }
`;

const Avatar = ({
  threshold,
  size,
  shape,
  placeholder,
  alt,
  mode,
  ...props
}) => {
  const [color, setColor] = useState(``);

  const colorList = [
    '#D9B0D5',
    '#F2EDD0',
    '#ABD9D0',
    '#D9C589',
    '#F2F2F2',
    '#DED9C1',
    '#DABEAF',
    '#C6C5D9',
    '#ABDEDD',
    '#DEABD2',
    '#008E84',
    '#61BB99',
    '#C9965C',
    '#F1A889',
    '#CBD1C3',
  ];
  const random = colorList[Math.floor(Math.random() * colorList.length)];

  if (!color) setColor(random);

  return (
    <AvatarWrapper color={color} {...props} shape={shape} size={size}>
      <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADmUlEQVR4nO3cS2tdVRQA4C9VS5rUmDRREEGcOHCigv4BZw58FHzQiiiVQoeKI50pSv+A4FCpj2LFkYhgRyL4qiMFEQQh1kGx1aa21aotxsG+l8qFm5pkn7POuVkfrEEG2Wvvte953H32uaSUUkoppZRSSimllFJKKaWUUkoppZRSSilVMxXdgQ2awy2YHfz9O5ZxNqxHE24H9uJt/ITVMXEcb2HP4H/SJi3hIM4YX/RxsYKXsdh6ryfEfvxq/YUfjV/wVMt977WdeM/mCz8aR1y+ZqQxFnFM/eIP4wt5ShprBp9prvjDOKYcZWnEYc0XfxjvtjSm3tivveIPY18rI+uBJXXudtYbp7CrhfGtaVt0B/CsmEIs4ZmAvJ2yQ/nC1PanfxinMd34KNcQfQTsxnxg/gXcH5g/fALuC85PN/oQZq2Ftbbix8ZHuYbI5eg5/BaYf2gV1+FcRPLIU9DNgbn/a0pgXyInYC4w96iwvkRfhLe8yAno0uPDsL5EXoSv1Y1JWFVOQecjkkceAeeU29BoxwUVn/hrwCfB+eHjyOTRE/BBcH660YcwuRgXmRwX8Gpg/lfwZ2D+TlhUto60/ek/qayGJmXfTtsT8GQrI+uRI9or/uGWxtQrM/hU88X/Um7QGmtR2TzVVPE/14EH8V03i3c0c9qZaXEcvbdP2Tqy2cKflBfcDduFl5QvTOst/Gm8KG81q5jGI3hDeYY7rujLOISHBX/D/b/6+orSTuUVpeEm2/NK8cNWNVNKKaXUM325C1rAnbgdNw7+nld2tFF22J1RHu6cwNeDWGm9pxNiHo8pK6Rr3fdfKZaVZY29Lk9WGmM7nsBR/K3+WtBf+AiP45qWxtQLc3ha2R7S1CroaJzAC7b4yuh2PK9szmqr8KNxFs8N+rKl3INvxRV+NL7HvY2OuCNm8ab4go+LQyb4admt+EZ8ka8U3+G2hmoQ5gEb+8mZqFgxQe+OPYqL4ou63rik3LL2Wl+LPxGTsEcZQHQRNxsXladxvXIH/hBfvFpxAXdVrVCDFvCD+KLVjmXl9yU6bRs+FF+spuIorqpWrQYcEF+kpuNAtWpVNo2fxReo6Til4g67mi9o7MYNFdvrqiU8VKuxmhMQ+rMvLas21poT0JvbtArurtVQzQm4qWJbXXd9rYZqTsBqxba67p9aDdWcgNcrttV1r9VqqOa2lCk8qJwfr67Ybpdcwld439Y64lNKKTXgX/IVyMR991meAAAAAElFTkSuQmCC"
        alt="userProfile"
      />
    </AvatarWrapper>
  );
};

Avatar.defaultProps = {
  threshold: 0.5,
  size: 'base',
  shape: 'circle',
  mode: 'cover',
  placeholder: '',
};

Avatar.propTypes = {
  threshold: PropTypes.number,
  size: PropTypes.oneOf(['sm', 'base', 'md']),
  shape: PropTypes.oneOf(['circle', 'round', 'square']),
  placeholder: PropTypes.string,
  alt: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(['cover', 'fill', 'contain']),
};

export default Avatar;
